var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 459.15,
    height: 549,
    viewBox: "0 0 459.15 549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_2783",
    x: 0,
    y: 0,
    width: 459.15,
    height: 549,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(8404.5 -1541.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(-8450 1557)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -18.5, -15.5)",
    filter: "url(#Path_2783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2783-2",
    "data-name": "Path 2783",
    d: "M365.45,3.125A12.333,12.333,0,0,0,357.159,0H110.9C85.036,0,64,19.135,64,42.667V469.334C64,492.865,85.036,512,110.906,512H439.245c25.869,0,46.9-19.135,46.9-42.667v-352Zm80.665,103.542Z",
    transform: "translate(-45.5 15.5)",
    fill: "#fff",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2786",
    "data-name": "Path 2786",
    d: "M299.408,304.561a290.534,290.534,0,0,1-23.975-20.685c-7.636-7.636-14.44-15.037-20.353-22.086,9.222-28.5,13.265-43.192,13.265-51.024,0-33.275-12.022-40.1-30.074-40.1-13.716,0-30.074,7.127-30.074,41.059,0,14.959,8.194,33.119,24.435,54.225-3.974,12.129-8.644,26.119-13.891,41.89-2.526,7.567-5.267,14.577-8.165,21.057-2.359,1.048-4.65,2.115-6.863,3.221-7.969,3.985-15.536,7.567-22.556,10.9C149.146,358.169,128,368.194,128,387.989c0,14.372,15.615,23.27,30.074,23.27,18.639,0,46.785-24.9,67.343-66.835,21.341-8.419,47.872-14.656,68.812-18.561,16.779,12.9,35.312,25.248,44.289,25.248,24.856,0,30.074-14.372,30.074-26.423,0-23.7-27.079-23.7-40.1-23.7C324.45,300.987,313.6,302.182,299.408,304.561ZM158.074,391.21c-5.727,0-9.6-2.7-10.025-3.221,0-7.108,21.195-17.152,41.695-26.863,1.3-.617,2.624-1.234,3.965-1.87C178.652,381.088,163.762,391.21,158.074,391.21Zm70.173-179.485c0-21.009,6.52-21.009,10.025-21.009,7.088,0,10.025,0,10.025,20.049,0,4.229-2.819,14.8-7.979,31.308C232.446,229.953,228.247,219.566,228.247,211.725Zm7.685,107.746q.94-2.614,1.821-5.286c3.72-11.16,7.068-21.185,10.054-30.211q6.241,6.872,13.452,14.077c1.88,1.88,6.539,6.109,12.747,11.4C261.649,312.148,248.5,315.486,235.932,319.471Zm112.611,5.218c0,4.5,0,6.373-9.3,6.432-2.731-.587-9.046-4.307-16.839-9.613,2.829-.313,4.914-.47,6.089-.47C343.306,321.037,347.506,322.486,348.544,324.689Z",
    transform: "translate(-8423 1522.334)",
    fill: "#e65555"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.494767cfe170e4d0263a1a80863e7803.svg";
export { ForwardRef as ReactComponent };